module.exports = __webpack_public_path__ + "img/giftCategoryDefault.c6ad4479.jpg";